import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-black text-xl">
                91
              </span>
              <span className="font-black text-2xl text-background-50 tracking-tight">
                91<span className="text-primary-400">n</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/85">
              91n 影视大全聚合海量电影与电视剧资源，涵盖最新上映影片、热播剧集与经典影视作品，为影视爱好者提供便捷的发现与浏览体验。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-base">内容导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200/85 hover:text-primary-300 transition-colors">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-background-200/85 hover:text-primary-300 transition-colors">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-background-200/85 hover:text-primary-300 transition-colors">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-200/85 hover:text-primary-300 transition-colors">
                  影视搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-base">热门专题</h4>
            <ul className="space-y-2.5 text-sm">
              <li className="text-background-200/85">豆瓣高分电影</li>
              <li className="text-background-200/85">经典必看电视剧</li>
              <li className="text-background-200/85">科幻宇宙精选</li>
              <li className="text-background-200/85">国风古装大剧</li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-base">关于我们</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-background-200/85 hover:text-primary-300 transition-colors">
                  网站介绍
                </Link>
              </li>
              <li className="flex items-center gap-2 text-background-200/85">
                <i className="ri-mail-line text-base"></i>
                contact@91n.example
              </li>
              <li className="flex items-center gap-2 text-background-200/85">
                <i className="ri-time-line text-base"></i>
                全年无休 · 每日更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/70">
          <p>© {new Date().getFullYear()} 91n影视大全 · 本站为影视信息演示站点，仅供学习交流使用。</p>
          <p>所有影视资料均为演示数据，不提供真实播放与下载服务。</p>
        </div>
      </div>
    </footer>
  );
}